import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _get from 'lodash/get';
import React, { Component } from 'react';
import classes from './LogEdit.module.css';
import Button from 'components/UI/Button/Button';
import { getRgbFromColorName, truncateText } from 'shared/utility';

class LogEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditingLogName: false,
      logName: '',
      showArchivedList: false,
      removeAccordianExpanded: false,
    };
  }

  componentDidMount() {
    if (this.props.log && this.props.log.Log && this.props.log.Log.Name) this.setState({ logName: this.props.log.Log.Name });
  }

  componentDidUpdate(prevProps) {
    if (
      (!prevProps.log && this.props.log && this.props.log.Log && this.props.log.Log.Name) ||
      (prevProps.log && this.props.log && prevProps.log.Log.Name !== this.props.log.Log.Name)
    )
      this.setState({ logName: this.props.log.Log.Name, isEditingLogName: false, showArchivedList: false });

    // Update LogCard Flipper height when we toggle user actions
    if (this.props.editingMemberId !== prevProps.editingMemberId) this.props.setFlipperHeight(true);
    if (
      this.props.log &&
      this.props.log.UsersArchived &&
      this.props.log.UsersArchived.length === 0 &&
      prevProps.log &&
      prevProps.log.UsersArchived &&
      prevProps.log.UsersArchived.length > 0 &&
      this.state.showArchivedList
    )
      this.setState({ showArchivedList: false });
  }

  openRemoveUserFromLogConfirmation = (editingMemberId, removeContent, isArchived) => {
    this.props.handleSetEditingMemberId(editingMemberId);
    if (isArchived) {
      this.props.handleToggleDialogue('DeleteArchivedMember');
    } else if (removeContent) {
      this.props.handleToggleDialogue('RemoveMemberAndContent');
    } else {
      this.props.handleToggleDialogue('RemoveMemberKeepContent');
    }
  };

  handleCancelLogNameEdit = () => {
    const logName = this.props.log && this.props.log.Log && this.props.log.Log.Name ? this.props.log.Log.Name : '';
    this.setState({ logName, isEditingLogName: false });
  };

  handleLogMemberAccessUpdate = (memberId, newAccessLevel, currentAccessLevel) => {
    if (newAccessLevel !== currentAccessLevel) {
      const logAlreadyHasCohost = this.props.members.find((member) => member.Access === 'Co-host');
      if (newAccessLevel === 'Co-host' && logAlreadyHasCohost) {
        this.props.handleToggleDialogue('LogAlreadyHasCoHost');
      } else if (newAccessLevel === 'Host') {
        if (!logAlreadyHasCohost) {
          this.props.handleToggleDialogue('CoHostRequiredForTransfer');
        } else {
          this.props.handleToggleDialogue('ConfirmTransfer');
        }
      }
      // If a member+ is attempting to change their access level to Member, confirm
      else if (newAccessLevel === 'Member' && currentAccessLevel === 'Member+' && memberId === this.props.postingAs.UserId) {
        this.props.handleToggleDialogue('MemberPlusToMember');
      } else {
        this.props.handleLogMemberAccessUpdate(this.props.log.Log.Id, memberId, newAccessLevel);
      }
    }
  };

  toggleMemberEdit = (userId) => {
    if (this.state.removeAccordianExpanded) this.setState({ removeAccordianExpanded: false });
    this.props.toggleMemberEdit(userId);
  };

  toggleRemoveUserAccordian = () => {
    this.setState({ removeAccordianExpanded: !this.state.removeAccordianExpanded });
    this.props.setFlipperHeight(true, !this.state.removeAccordianExpanded);
  };

  handleLogNameUpdate = (logId, logName) => {
    this.props.handleLogNameUpdate(logId, logName);
    this.setState({ isEditingLogName: false, logName });
  };

  render = () => {
    let roleChangePermissions = ['Remove Self'];
    let membersList = null;
    const editingUser = this.props.members.find((member) => this.props.postingAs.UserId === member.UserId)
      ? this.props.members.find((member) => this.props.postingAs.UserId === member.UserId)
      : {};
    const logHasCohost = this.props.members.filter((member) => member.Access === 'Co-host').length > 0;
    if (editingUser) {
      if (editingUser.Access === 'Host') {
        roleChangePermissions = [
          'TitleUpdate',
          'AddMembers',
          'RemoveMembers',
          'MakeCoHost',
          'MakeMemberPlus',
          'MakeMember',
          'TransferLogOwnership',
          'FlagContent',
          'DeleteLog',
          'RemoveSelfAddedMembers',
          'RemoveSelf',
        ];
      } else if (editingUser.Access === 'Co-host') {
        roleChangePermissions = [
          'TitleUpdate',
          'MakeMemberPlus',
          'MakeMember',
          'AddMembers',
          'RemoveMembers',
          'FlagContent',
          'RemoveSelfAddedMembers',
          'RemoveSelf',
        ];
      } else if (editingUser.Access === 'Member+') {
        roleChangePermissions = ['AddMembers', 'RemoveSelfAddedMembers', 'RemoveSelf'];
      }
    }

    if (this.state.showArchivedList) {
      membersList = this.props.log.UsersArchived.map((member, i) => {
        const isEditable = editingUser && this.props.isCreated && roleChangePermissions.includes('RemoveMembers');
        const imageURL = _get(member, 'ImageURL', _get(member, 'ThumbURL'));
        return (
          <div key={`member-${i}`} className={[classes.MemberContainer, classes.ArchivedMember].join(' ')}>
            <div
              className={isEditable ? [classes.Member, classes.Editable].join(' ') : classes.Member}
              onClick={isEditable ? () => this.toggleMemberEdit(member.UserId) : undefined}
            >
              {imageURL ? (
                <img
                  src={imageURL}
                  alt={`${member.FirstName}'s photo`}
                  className={classes.ProfileImage}
                  style={{ border: `3px solid ${member.Color ? getRgbFromColorName(member.Color) : 'rgb(108, 162, 183)'}` }}
                />
              ) : (
                <FontAwesomeIcon
                  icon="user-circle"
                  style={{ color: `3px solid ${member.Color ? getRgbFromColorName(member.Color) : 'rgb(108, 162, 183)'}` }}
                  className={classes.AvatarIcon}
                />
              )}
              <div className={classes.MemberDetails}>
                <p className={classes.MemberName}>{`${member.FirstName} ${member.LastName}`}</p>
                <p className={classes.MemberDateRange}>
                  Member from {member.DateAdded} to {member.DateRemoved}
                </p>
              </div>
            </div>
            <div
              className={
                isEditable && this.props.editingMemberId === member.UserId
                  ? [classes.EditMemberActions, classes.Show].join(' ')
                  : classes.EditMemberActions
              }
            >
              <p className={classes.RemoveMember} onClick={() => this.openRemoveUserFromLogConfirmation(member.UserId, null, true)}>
                Remove archived member’s content from log
              </p>
            </div>
          </div>
        );
      });
    } else {
      membersList = this.props.members.map((member, i) => {
        let isEditable =
          editingUser &&
          this.props.isCreated &&
          (roleChangePermissions.includes('MakeMember') ||
            member.UserId === editingUser.UserId ||
            (roleChangePermissions.includes('RemoveSelfAddedMembers') &&
              member.InvitedByUserId === editingUser.UserId &&
              member.Access === 'Member'));
        // If editing user is a host and the log does not have a co-host, they cannot edit themselves
        if (member.Access === 'Host' && editingUser.UserId === member.UserId && !logHasCohost) isEditable = false;
        const imageURL = _get(member, 'ImageURL', _get(member, 'ThumbURL'));
        return (
          <div key={`member-${i}`} className={classes.MemberContainer}>
            <div
              className={isEditable ? [classes.Member, classes.Editable].join(' ') : classes.Member}
              onClick={isEditable ? () => this.toggleMemberEdit(member.UserId) : undefined}
            >
              {imageURL ? (
                <img
                  src={imageURL}
                  alt={`${member.FirstName}'s photo`}
                  className={classes.ProfileImage}
                  style={{ border: `3px solid ${member.Color ? getRgbFromColorName(member.Color) : 'rgb(108, 162, 183)'}` }}
                />
              ) : (
                <FontAwesomeIcon
                  icon="user-circle"
                  style={{ color: `3px solid ${member.Color ? getRgbFromColorName(member.Color) : 'rgb(108, 162, 183)'}` }}
                  className={classes.AvatarIcon}
                />
              )}
              <div className={classes.MemberDetails}>
                <p className={classes.MemberName}>{`${member.FirstName} ${member.LastName}`}</p>
                <p className={isEditable ? [classes.MemberRole, classes.Editable].join(' ') : classes.MemberRole}>{member.Access}</p>
              </div>
            </div>
            <div
              className={
                isEditable && this.props.editingMemberId === member.UserId
                  ? [classes.EditMemberActions, classes.Show].join(' ')
                  : classes.EditMemberActions
              }
            >
              <div className={classes.RoleActions}>
                {roleChangePermissions.includes('MakeMember') ||
                member.UserId === editingUser.UserId ||
                (roleChangePermissions.includes('RemoveSelfAddedMembers') &&
                  member.InvitedByUserId === editingUser.UserId &&
                  member.Access === 'Member') ? (
                  <div className={classes.Action} onClick={() => this.handleLogMemberAccessUpdate(member.UserId, 'Member', member.Access)}>
                    <p>Member</p>
                    {member.Access === 'Member' ? <FontAwesomeIcon icon="check" className={classes.CheckedIcon} /> : null}
                  </div>
                ) : null}
                {roleChangePermissions.includes('MakeMemberPlus') || (editingUser.Access === 'Member+' && editingUser.UserId === member.UserId) ? (
                  <div className={classes.Action} onClick={() => this.handleLogMemberAccessUpdate(member.UserId, 'Member+', member.Access)}>
                    <p>Member+</p>
                    {member.Access === 'Member+' ? <FontAwesomeIcon icon="check" className={classes.CheckedIcon} /> : null}
                  </div>
                ) : null}
                {roleChangePermissions.includes('MakeCoHost') ? (
                  <div className={classes.Action} onClick={() => this.handleLogMemberAccessUpdate(member.UserId, 'Co-host', member.Access)}>
                    <p>Co-Host</p>
                    {member.Access === 'Co-host' ? <FontAwesomeIcon icon="check" className={classes.CheckedIcon} /> : null}
                  </div>
                ) : null}
              </div>
              {roleChangePermissions.includes('RemoveMembers') ||
              member.UserId === editingUser.UserId ||
              (roleChangePermissions.includes('RemoveSelfAddedMembers') && member.InvitedByUserId === editingUser.UserId) ? (
                <div className={classes.Remove}>
                  <div className={classes.RemoveAction} onClick={this.toggleRemoveUserAccordian}>
                    <p>{member.UserId === editingUser.UserId ? 'Remove myself from this log' : 'Remove this member'}</p>
                    <FontAwesomeIcon icon="chevron-down" className={classes.ExpandIcon} />
                  </div>
                  <div className={this.state.removeAccordianExpanded ? [classes.RemoveOptions, classes.Expanded].join(' ') : classes.RemoveOptions}>
                    <p className={classes.RemoveMember} onClick={() => this.openRemoveUserFromLogConfirmation(member.UserId, false)}>
                      {member.UserId === editingUser.UserId ? 'Keep the content that I added to this log' : 'Keep the content they added to this log'}
                    </p>
                    <p className={classes.RemoveMember} onClick={() => this.openRemoveUserFromLogConfirmation(member.UserId, true)}>
                      {member.UserId === editingUser.UserId
                        ? 'Remove myself and my content from this log'
                        : 'Remove all the content they added to this log'}
                    </p>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        );
      });
    }

    return (
      <div>
        <div className={classes.LogEditContainer}>
          <div className={classes.Header}>
            <span className={classes.Done} onClick={this.props.done}>
              Done
            </span>
            <h3>Log ⚙</h3>
            <Button
              btnType="SavePost"
              disabled={this.props.addMembersVisible}
              clicked={this.props.addMembersVisible ? undefined : this.props.handleAddMembersToggle}
            >
              Add Members
            </Button>
          </div>
          {this.state.isEditingLogName ? (
            <div className={classes.EditLogNameForm}>
              <div className={classes.InputContainer}>
                <p className={classes.Label}>Log Name:</p>
                <input value={this.state.logName} onChange={(e) => this.setState({ logName: e.target.value })} placeholder="Untitled" />
                <p className={classes.ErrorMessage}>{this.props.error}</p>
              </div>
              <div className={classes.Actions}>
                <span className={classes.Cancel} onClick={this.handleCancelLogNameEdit}>
                  Cancel
                </span>
                <button className={classes.SaveButton} onClick={() => this.handleLogNameUpdate(this.props.log.Log.Id, this.state.logName)}>
                  Save
                </button>
              </div>
            </div>
          ) : (
            <div>
              <h2 className={classes.LogName}>{truncateText(this.state.logName, 25)}</h2>
              {this.props.log && this.props.log.Log.Visibility !== 'Private' && roleChangePermissions.includes('TitleUpdate') ? (
                <span className={classes.EditLogName} onClick={() => this.setState({ isEditingLogName: true })}>
                  Edit
                </span>
              ) : null}
            </div>
          )}
          {this.props.log && this.props.log.UsersArchived && this.props.log.UsersArchived.length > 0 ? (
            <div className={classes.MembersTabs}>
              <p
                className={!this.state.showArchivedList ? [classes.MemberTab, classes.Active].join(' ') : classes.MemberTab}
                onClick={() => this.setState({ showArchivedList: false })}
              >
                Active Members
              </p>
              <p
                className={this.state.showArchivedList ? [classes.MemberTab, classes.Active].join(' ') : classes.MemberTab}
                onClick={() => this.setState({ showArchivedList: true })}
              >
                Archived Members
              </p>
            </div>
          ) : null}
          <div className={classes.MembersList}>{membersList}</div>
          {this.props.log && roleChangePermissions.includes('TransferLogOwnership') && this.props.log.Log.Visibility !== 'Private' ? (
            <div className={classes.TransferLogOwnership} onClick={() => this.handleLogMemberAccessUpdate(null, 'Host', null)}>
              <FontAwesomeIcon icon="rocket" className={classes.TransferIcon} />
              <span>Transfer Log to Co-host</span>
            </div>
          ) : null}
          {this.props.log && roleChangePermissions.includes('DeleteLog') && this.props.log.Log.Visibility !== 'Private' ? (
            <div className={classes.DeleteLog} onClick={() => this.props.handleToggleDialogue('DeleteLog')}>
              <FontAwesomeIcon icon={['far', 'trash-alt']} className={classes.DeleteIcon} />
              <span>Delete Log</span>
            </div>
          ) : null}
        </div>
      </div>
    );
  };
}

export default LogEdit;
